module.exports = __webpack_public_path__ + "static/media/banner-bg.a8cbcc46.png";